/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Per-asset import status
 */
export type PublicAssetImportResultDto = {
    /**
     * Failure message, present only when the asset failed to import
     */
    message?: string | null;
    /**
     * Import status of the asset
     */
    status?: PublicAssetImportResultDto.status;
    /**
     * URI of the asset
     */
    uri?: string;
};

export namespace PublicAssetImportResultDto {

    /**
     * Import status of the asset
     */
    export enum status {
        SUCCESS = 'SUCCESS',
        FAILED = 'FAILED',
    }


}
